import React from "react";
import { Box, Typography } from "@mui/material";
import { HalfDonutChartWithData } from "@components/Chart/highcharts";

type Props = {
  chartData?: {
    name: string;
    y: number;
  }[];
  title: string;
};

export const Holdings = ({ chartData, title }: Props) => {
  if (!chartData) {
    return null;
  }

  return (
    <Box
      py={8}
      sx={{
        borderBottom: 1,
        borderColor: "border.secondary",
        overflow: "hidden",
      }}
    >
      <Typography variant="body1" mb={4}>
        {title}
      </Typography>
      <HalfDonutChartWithData data={chartData} />
    </Box>
  );
};
